import { useMemo, useCallback } from 'react'
import cacheStorage from 'sw-modules/cache-storage'
import { useQuery, graphqlFetch } from 'sw-modules/gql-module'


type BlacklistedVaultsQueryVariables = BackendGraph.Exact<{ [key: string]: never; }>
type BlacklistedVaultsQueryPayload = { vaults: Array<{ address: string }> }


const query = 'query BlacklistedVaults { vaults(blacklisted: true) { address: id }}'

const getBlacklistedVaultsQueryCache = (url: string) => cacheStorage.get<Record<string, BlacklistedVaultsQueryPayload>>(`${UNIQUE_FILE_ID}_${url}`)

const fetchBlacklistedVaultsQuery = <ModifiedData = BlacklistedVaultsQueryPayload>(
  { url, variables, requestPolicy, modifyResult }: ModuleGQL.FetchCodegenInput<BlacklistedVaultsQueryPayload, BlacklistedVaultsQueryVariables, ModifiedData>
) => (
  graphqlFetch<BlacklistedVaultsQueryPayload, BlacklistedVaultsQueryVariables, ModifiedData>({
    cache: getBlacklistedVaultsQueryCache(url),
    url,
    query,
    variables,
    requestPolicy,
    modifyResult,
  })
)

const useBlacklistedVaultsQuery = <ModifiedData = BlacklistedVaultsQueryPayload>(
  {
    urls,
    pause,
    variables,
    modifyResult,
    resetDataKeys,
  }: ModuleGQL.UseQueryCodegenInput<BlacklistedVaultsQueryPayload, BlacklistedVaultsQueryVariables, ModifiedData>
): ModuleGQL.UseQueryOutput<ModifiedData> => {
  const _modifyResult = useCallback((data: BlacklistedVaultsQueryPayload) => {
    if (typeof modifyResult === 'function') {
      return modifyResult(data) as ModifiedData
    }

    return data as ModifiedData
  }, [ modifyResult ])

  const cache = useMemo(() => getBlacklistedVaultsQueryCache(urls.backend), [ urls.backend ])

  return useQuery({
    cache,
    url: urls.backend,
    resetDataKeys,
    query,
    pause,
    variables,
    modifyResult: _modifyResult,
  })
}


export {
  useBlacklistedVaultsQuery,
  fetchBlacklistedVaultsQuery,
  getBlacklistedVaultsQueryCache,
}
export type { BlacklistedVaultsQueryPayload, BlacklistedVaultsQueryVariables }
